"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const utils_1 = require("../../utils");
const HelloPage = () => (react_1.default.createElement("div", null,
    react_1.default.createElement("span", { className: "inline-block text-[3rem] [transform-origin:70%_70%] animate-wave", "aria-hidden": "true" }, "\uD83D\uDC4B"),
    react_1.default.createElement("h1", { className: "text-[3.2rem] max-lg:text-[2.2rem] font-bold my-[15px]" }, "Hi, I am Avanthika"),
    react_1.default.createElement("div", { className: "text-base mb-[15px]" }, utils_1.staticContent.map((content) => content))));
exports.default = HelloPage;
